const fakeSelectInput = (comboboxContainer) => {
    const elements = {
      button: comboboxContainer.querySelector('[role="combobox"]'),
      dropdown: comboboxContainer.querySelector('[role="listbox"]'),
      options: comboboxContainer.querySelectorAll('[role="option"]'),
    };
  
    let isDropdownOpen = false;
    let currentOptionIndex = 0;
  
    const toggleDropdown = (event) => {
      event.preventDefault();
  
      closeAllDropdowns();
      isDropdownOpen = !isDropdownOpen;
      elements.dropdown.classList.toggle('active', isDropdownOpen);
      elements.button.setAttribute('aria-expanded', isDropdownOpen);
  
      if (isDropdownOpen) {
        focusCurrentOption();  // Focus sur la première option quand on ouvre
      }
    };
  
    const handleDocumentInteraction = (event) => {
      const clickedOption = event.target.closest('[role="option"]');
      if (clickedOption) {
        selectOptionByElement(clickedOption);
      }
    };
  
    const handleOutsideClick = (event) => {
      if (!comboboxContainer.contains(event.target)) {
        closeDropdown();
      }
    };
  
    const closeDropdown = () => {
      isDropdownOpen = false;
      elements.dropdown.classList.remove('active');
      elements.button.setAttribute('aria-expanded', 'false');
    };
  
    const moveFocusDown = () => {
      if (currentOptionIndex < elements.options.length - 1) {
        currentOptionIndex++;
      } else {
        currentOptionIndex = 0; // Retour au début
      }
      focusCurrentOption();
    };
  
    const moveFocusUp = () => {
      if (currentOptionIndex > 0) {
        currentOptionIndex--;
      } else {
        currentOptionIndex = elements.options.length - 1; // Aller à la fin si c'est le début
      }
      focusCurrentOption();
    };
  
    const focusCurrentOption = () => {
      const currentOption = elements.options[currentOptionIndex];
  
      if (currentOption) {
        // Appliquer le focus à l'élément sélectionné
        currentOption.classList.add('current');
        currentOption.focus();  // Applique le focus à l'option courante
  
        // Enlever la classe 'current' des autres options
        elements.options.forEach((option) => {
          if (option !== currentOption) {
            option.classList.remove('current');
          }
        });
      }
    };
  
    const selectCurrentOption = () => {
      const selectedOption = elements.options[currentOptionIndex];
      selectOptionByElement(selectedOption);
    };
  
    const selectOptionByElement = (optionElement) => {
      const optionValue = optionElement.textContent;
  
      // Remplacer le texte du bouton par l'option sélectionnée
      elements.button.value = optionValue;
      elements.button.querySelector('.fake-select-input__value').innerText = optionValue
      elements.options.forEach((option) => {
        option.classList.remove('active');
        option.setAttribute('aria-selected', 'false');
      });
  
      // Marquer l'élément sélectionné
      optionElement.classList.add('active');
      optionElement.setAttribute('aria-selected', 'true');
  
      closeDropdown();
      elements.button.value = optionValue;
      for (const [key, value] of Object.entries(optionElement.dataset)) {
        elements.button.setAttribute(`data-${key}`, value);
      }

      Object.entries(optionElement.dataset).forEach(([key,value])=> {
        optionElement.closest('.fake-select-input-content').querySelector('button .fake-select-input__value').dataset[key] = value
    })
    optionElement.closest('.fake-select-input-content').querySelector('button .fake-select-input__value').innerHTML = optionElement.innerHTML
    optionElement.closest('.fake-select-input-content').querySelector('button').dispatchEvent(new CustomEvent('fakeinput'))
    };
  
    const handleKeyPress = (event) => {
      const { key } = event;
      const openKeys = ['ArrowDown', 'ArrowUp', 'Enter', ' '];
  
      if (!isDropdownOpen && openKeys.includes(key)) {
        toggleDropdown(event); // Ouvrir le dropdown avec les touches "Entrée" ou "Espace"
      } else if (isDropdownOpen) {
        switch (key) {
          case 'Escape':
            closeDropdown(); // Fermer sur "Echap"
            break;
          case 'ArrowDown':
            event.preventDefault(); // Empêche le scrolling natif de la page
            moveFocusDown(); // Descendre dans la liste
            break;
          case 'ArrowUp':
            event.preventDefault(); // Empêche le scrolling natif de la page
            moveFocusUp(); // Monter dans la liste
            break;
          case 'Enter':
          case ' ':
            event.preventDefault(); 
            selectCurrentOption(); 

            break;
          default:
            break;
        }
      }
    };
  
    elements.button.addEventListener('click', toggleDropdown);
    elements.dropdown.addEventListener('click', handleDocumentInteraction);
    elements.button.addEventListener('keydown', handleKeyPress); 
    document.addEventListener('click', handleOutsideClick); 





    // elements.options.forEach(element => {
    //   element.addEventListener('click', function(e){
    //           Object.entries(element.dataset).forEach(([key,value])=> {
    //               element.closest('.fake-select-input-content').querySelector('button .fake-select-input__value').dataset[key] = value
    //           })
    //           element.closest('.fake-select-input-content').querySelector('button .fake-select-input__value').innerHTML = element.innerHTML
    //           element.closest('.fake-select-input-content').querySelector('button').dispatchEvent(new CustomEvent('fakeinput'))
    //       })
    // });

  
      
      
  }
  
  const closeAllDropdowns = () => {
    document.querySelectorAll('[role="listbox"].active').forEach((dropdown) => {
      dropdown.classList.remove('active');
      const button = dropdown.previousElementSibling;
      button.setAttribute('aria-expanded', 'false');
    });
  };
  

  
  export {fakeSelectInput}